import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Relationship Resolutions of Pennsylvania theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const RELPRESOL_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/relpresol/logo.png",
        alt: "Relationship Resolutions of Pennsylvania Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 41,
  state: "PA",
  departmentIds: [209, 210, 211, 212],
};
